import {Component, Input, OnInit} from '@angular/core';
import { SessionStorage } from '../../../../core/services/global/storage/session-storage.service';
import {isKIOSKPOLIS, isMPay, isSkycash, salesChannel} from '../../../../core/utils/utils';
import { SalesChannel } from '../../../../core/consts/sales-channel.enum';
import { NotificationStateService } from '../../../services/notification-state.service';
import {OlxAnalyticsService} from '../../../services/olx-analytics.service';
import {ApplicationStateService} from '../../../services/application-state.service';
import {UrlParamsService} from '../../../../core/services/impl/url-params.service';
import {NotificationState} from '../../../models/notification-state';
import {PaymentMethod} from '../../../../core/consts/payment-method.enum';

@Component({
  selector: 'app-positive-notification-web',
  templateUrl: './positive-notification-web.component.html',
  styleUrls: ['./positive-notification-web.component.scss']
})
export class PositiveNotificationWebComponent implements OnInit {

  @Input() notificationState: NotificationState;
  startDate: string;
  endDate: string;

  get canShowPolicyPaidMessage(): boolean {
    return this.notificationState.paymentMethod !== PaymentMethod.STANDARD_TRANSFER;
  }

  get canShowMpayMessage(): boolean {
    return (isMPay() || isSkycash()) && this.urlParamsService.isMobileOrigin && this.notificationState.status === 200;
  }

  get imageVisible(): boolean {
    return !isKIOSKPOLIS();
  }

  constructor(private sessionStorage: SessionStorage,
              private olxAnalyticsService: OlxAnalyticsService,
              private stateService: ApplicationStateService,
              private urlParamsService: UrlParamsService,
              private notificationStateService: NotificationStateService) {
  }

  ngOnInit() {
    this.sendMetric();
  }

  backToHome() {
    this.sessionStorage.clear();
    window.location.href = 'http://www.kioskpolis.pl';
  }

  get backgroundLogo(): string {
    const path = './assets/images/icons/';
    switch (salesChannel()) {
      case SalesChannel.YANOSIK:
        return path + 'dziekujemy-yanosik.svg';
      case SalesChannel.MPAY:
        return path + 'thank-you-mpay.jpg';
      case SalesChannel.SKYCASH:
        return path + 'dziekujemy-oc-ac-skycash.svg';
      default:
        return path + 'dziekujemy-oc-ac.svg';
    }
  }

  private sendMetric(): void {
    const data = {
      paymentMethod: this.notificationState.paymentMethod,
      description: this.notificationState.message
    };
    this.notificationStateService.sendNotificationComponentMetric('PositiveNotificationWebComponent', data);

    if (this.stateService.salesChannel === SalesChannel.OLX) {
      this.olxAnalyticsService.sendNotificationStepEvent();
    }
  }
}
